<template>
    <div class="warpper padding-sm">
        <div class="flex align-center justify-between">
            <div class="classifys flex align-center">
                <router-link class="classify " to="/organization/fee/cost">会费管理</router-link>
                <router-link class="classify active" to="/organization/fee/fcost">分会会费管理</router-link>
            </div>
            <el-button class="margin-bottom-sm" type="primary" round @click="exportExcel">导出</el-button>
        </div>
        <div class="flex align-center justify-between margin-bottom-sm">
            <div class="page-title line-height">会费管理</div>
            <el-radio-group v-model="search">
                <el-radio :label="1" border>全部</el-radio>
                <el-radio :label="2" border>待审核</el-radio>
                <el-radio :label="3" border>待开发票</el-radio>
            </el-radio-group>
        </div>
        <div class="ship-list">
            <el-table
                    v-loading="loading"
                    :data="lists" header-row-class-name="table-header"
                    border
                    style="width: 100%; border-radius: 10px">
                <el-table-column label="机构名称" prop="name">
                    <template slot-scope="scope">
                        <div class="table-name"> {{ scope.row.user_type === 1 ?  scope.row.morgname : scope.row.personal_name}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="所属协会" prop="company">
                    <template slot-scope="scope">
                        <div class="table-name"> {{ scope.row.fh_name }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="lianxiren_phone" label="手机号" width="110px">
                    <template slot-scope="scope">
                        <div class="table-name">
                            {{scope.row.phone}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="lianxiren_phone" label="会员身份" width="100px">
                    <template slot-scope="scope">
                        <div class="table-name">
                            {{scope.row.rank_name}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="lianxiren_phone" label="年限" width="60px">
                    <template slot-scope="scope">
                        <div class="table-name">
                            {{scope.row.duration}}年
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="lianxiren_phone" label="缴费金额" width="80px">
                    <template slot-scope="scope">
                        <div class="table-name">
                            {{scope.row.total_price}}元
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="lianxiren_phone" label="缴费方式" width="80px">
                    <template slot-scope="scope">
                        <div class="table-name">
                            {{scope.row.pay_type === 1 ? '微信支付' : '公账支付'}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="发票">
                    <template slot-scope="scope">
                        <div class="table-name flex justify-center align-center">
                            <div class="table-name margin-right-sm"
                                 :class="{gray:(!scope.row.invoice_state && !scope.row.is_pay) || !scope.row.is_invoice}">
                                {{ scope.row.is_pay ? (scope.row.is_invoice ? (scope.row.invoice_state ? '已开发票' : '待开发票') : '待开发票' ) : '未支付'}}
                            </div>
                            <el-button class="table-operate"
                                       :disabled="(!scope.row.invoice_state && !scope.row.is_pay ) || !scope.row.is_invoice"
                                       @click="makeInvoice(scope.row,true)" v-if="scope.row.invoice_state===0">开票
                            </el-button>
                            <el-button class="table-operate line" @click="makeInvoice(scope.row,false)" v-else>查看</el-button>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <div class="flex justify-center  align-center">
                            <div class="table-name margin-right-sm" v-if="scope.row.is_pay">充值成功</div>
                            <el-button class="table-operate" @click="submitPay(scope.row.order_number)" v-else>确认
                            </el-button>
                            <el-button class="table-operate line" @click="onPreview(scope.row.pay_type_2_image)">查看</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
                class="page-all margin-top"
                background
                @current-change="init"
                :current-page.sync="page"
                :page-size="limit"
                layout="prev, pager, next, jumper"
                :total="total">
        </el-pagination>
        <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="srcList"></el-image-viewer>
        <result-message-dialog :applyDialogVisible="dialogSuccessVisible" :title="msg_title"
                               :tips="msg_tip" :iconfont="'el-icon-success'" :iconVisible="true"
                               @watchState="watchState"></result-message-dialog>
        <InvoiceDialog :apply-dialog-visible="invoiceDialogVisible" :info="cur_item" :disabled="cur_state"
                       @cancelDialog="cancelDialog" @fileSuccess="fileSuccess"></InvoiceDialog>
    </div>
</template>

<script>
    import {getFhOrderList, setIsPayState,setInvoiceState} from '@/api/organiz'
    import ResultMessageDialog from "@/components/ResultMessageDialog.vue";
    import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
    import InvoiceDialog from "../../../../components/InvoiceDialog";
    import {baseURL} from "@/config";
    export default {
        name: "cost",
        data() {
            return {
                search: 1,
                lists: [],
                page: 1,
                limit: 13,
                total: 0,
                loading: false,

                msg_title: '',
                msg_tip: '',
                dialogSuccessVisible: false,

                cur_item: '',
                cur_state: false,
                invoiceDialogVisible: false,

                showViewer: false,
                srcList: []
            }
        },
        computed: {
            user() {
                return this.$store.state.user
            }
        },
        created() {
            this.$emit('setIndex', [4, 0], '会费管理')
            this.init()
        },
        components: {InvoiceDialog, ResultMessageDialog,ElImageViewer},
        methods: {
            //  页面加载时请求
            async init() {
                this.loading = true
                let _data = await getFhOrderList(this.search, this.page, this.limit)
                this.loading = false
                if (_data.status === 200) {
                    this.lists = _data.msg.data
                    this.total = _data.msg.total
                } else {
                    this.lists = [];
                    this.total = 0;
                }
            },
            submitPay(order_number) {
                this.$confirm('您确定通过该续费吗？', '提醒', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    let _data = await setIsPayState(order_number, 1)
                    if (_data.status === 200) {
                        this.msg_title = '充值成功'
                        this.msg_tip = '充值成功'
                        this.dialogSuccessVisible = true
                        this.init()
                    }
                })
            },
            makeInvoice(item,state){
                this.cur_item = item
                this.cur_state = state
                this.invoiceDialogVisible  = true
            },
            fileSuccess(data){
                this.setInvoiceState(data.file_path)
            },
            async setInvoiceState(file_path){
                let _data = await setInvoiceState(this.cur_item.order_number,file_path, 1)
                if (_data.status === 200) {
                    this.cancelDialog()
                    this.msg_title = '开票成功'
                    this.msg_tip = '开票成功'
                    this.dialogSuccessVisible = true
                    this.init()
                }
            },
            onPreview(url) {
                this.srcList = [url]
                this.showViewer = true
            },
            closeViewer() {
                this.showViewer = false
            },
            watchState() {
                this.dialogSuccessVisible = false;
            },
            cancelDialog() {
                this.invoiceDialogVisible  = false
            },
            exportExcel(){
                window.open(`${baseURL}admin/order/queryExportFh?mid=${this.user.mid}&search=${this.search}`)
            }
        },
        filters: {},
        watch: {
            search(){
                this.page = 1
                this.init()
            }
        },
    }
</script>

<style scoped lang="scss">
    .warpper {
        background: #fff;
        border-radius: 10px;

        .classifys {
            margin-bottom: 20px;
            .classify {
                width: 120px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                border: 1px solid #ffb400;
                border-radius: 6px 0  0 6px;
                color: #ffb400;
                &.active {
                    background: #ffb400;
                    color: #FFFFFF;
                    border-radius: 0 6px 6px 0;

                }
            }
        }
        .table-name {
            font-size: 14px;
            color: #333333;
            text-align: center;
            &.gray {
                color: #999999;
            }
        }
        .table-operate {
            width: 60px;
            height: 30px;
            padding: 0;
            border-radius: 15px;
            background-color: #0a2240;
            border: solid 1px #0a2240;
            font-size: 14px;
            color: #ffffff;
            &.line {
                background-color: #ffffff;
                color: #0a2240;
            }
            &:disabled {
                background-color: #ffffff;
                border: solid 1px #dae0e6;
                color: #bcc6cf;
            }
        }
    }
</style>